import React from "react"
import { connect } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import { withTranslation } from "react-i18next"

import {
  AppBar,
  Drawer,
  Fab,
  Typography
} from "@material-ui/core"

import {
  ChevronLeft,
  ChevronRight,
  KeyboardArrowDown,
  KeyboardArrowUp
} from "@material-ui/icons"

import "./HKVDrawer.css"

const styles = theme => ({
  drawerPaper: {
    background: "#f5f5f5",
    boxShadow: "1px 0px 10px rgba(0,0,0,0.3)",
    textAlign: "left",
    padding: theme.spacing(1),
    boxSizing: "border-box",
    [theme.breakpoints.up("xs")]: {
      width: "95%"
    },
    [theme.breakpoints.up("sm")]: {
      width: 280
    },
    [theme.breakpoints.up(1500)]: {
      width: 360
    }
  },
  drawerPaperBottom: {
    background: "#f5f5f5",
    boxShadow: "1px 0px 10px rgba(0,0,0,0.3)",
    textAlign: "left",
    padding: theme.spacing(1),
    height: 280,
    // normaal zit de transition alleen op de transform, maar deze willen we ook op de margin-left en de margin-right
    transition: "transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms, margin-left 225ms cubic-bezier(0, 0, 0.2, 1) 0ms, margin-right 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !important"
  },
  header: {
    flexDirection: "row",
    position: "sticky",
    top: 0,
    padding: theme.spacing(0.5, 1),
    background: theme.palette.primary.main,
    width: "100%"
  },
  headerimage: {
    height: 40,
    width: "auto"
  },
  drawerButton: {
    position: "absolute",
    transition: "225ms cubic-bezier(0, 0, 0.2, 1) 0ms"
  },
  drawerButtonLeft: {
    left: theme.spacing(1),
    top: theme.spacing(1)
  },
  drawerButtonRight: {
    right: theme.spacing(1),
    top: theme.spacing(1)
  },
  drawerButtonBottom: {
    left: theme.spacing(1),
    bottom: theme.spacing(1)
  },
  title: {
    width: "100%",
    alignSelf: "center",
    margin: theme.spacing(0, 1),
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }
})

class HKVDrawer extends React.Component {
  constructor(props) {
    super(props)

    const { config } = this.props

    this.state = {
      open: config.defaultOpen
    }
  }

  componentDidMount = () => {
    const { config, drawerStateChanged } = this.props

    drawerStateChanged(config.placement, config.defaultOpen)
    this.determineDrawerClass(config.placement)
  }

  toggleDrawer = () => {
    const { config, drawerStateChanged } = this.props

    drawerStateChanged(config.placement, !this.state.open)
    this.setState({ open: !this.state.open }, () => {
      this.determineDrawerClass(config.placement)
    })
  }

  determineButtonClass = (placement) => {
    const { classes } = this.props

    let className = ""
    switch (placement) {
      case "left": className = classes.drawerButtonLeft; break
      case "right": className = classes.drawerButtonRight; break
      case "bottom": className = classes.drawerButtonBottom; break
      default: break
    }

    return `${className} ${classes.drawerButton}`
  }

  determineDrawerClass = (placement) => {
    const { open } = this.state

    const drawerBottom = document.getElementById("drawer-bottom")
    const buttonBottom = document.getElementById("button-bottom")

    switch (placement) {
      case "left":
        if (drawerBottom) {
          if (open) {
            drawerBottom.classList.add("drawerPaperBottomOpenLeft")
            buttonBottom.classList.add("drawerButtonOpenLeft")
          } else {
            drawerBottom.classList.remove("drawerPaperBottomOpenLeft")
            buttonBottom.classList.remove("drawerButtonOpenLeft")
          }
        }
        break

      case "right":
        if (drawerBottom) {
          if (open) {
            drawerBottom.classList.add("drawerPaperBottomOpenRight")
          } else {
            drawerBottom.classList.remove("drawerPaperBottomOpenRight")
          }
        }
        break
    
      default:
        break
    }
  }

  determineIcon = (placement) => {
    const { open } = this.state

    switch (placement) {
      case "right":
        return open ? <ChevronRight /> : <ChevronLeft />

      case "bottom":
        return open ? <KeyboardArrowDown /> : <KeyboardArrowUp />

      case "left":
      default:
        return open ? <ChevronLeft /> : <ChevronRight />
    }
  }

  render() {
    const { classes, config } = this.props
    const { open } = this.state

    return (
      <React.Fragment>
        <Drawer
          id={`drawer-${config.placement}`}
          anchor={config.placement}
          variant="persistent"
          classes={{ paper: `${config.placement === "bottom" ? classes.drawerPaperBottom : classes.drawerPaper}` }}
          open={open}
        >
          <AppBar className={classes.header} dir={config.placement === "left" ? "ltr" : "rtl"}>
            {config.image && <img src={config.image} className={classes.headerimage} alt={config.title} />}
            <Typography variant="h5" className={classes.title} title={config.title}>{config.title}</Typography>
            {config.toggleButton && <Fab
              size="small"
              color="primary"
              onClick={() => this.toggleDrawer()}
              style={{ alignSelf: "center", flexShrink: 0, boxShadow: "none" }}
            >
              {this.determineIcon(config.placement)}
            </Fab>}
          </AppBar>
          {this.props.children}
        </Drawer>
        {
          (window.innerWidth <= 600 || config.toggleButton !== false) && <Fab
            id={`button-${config.placement}`}
            size="small"
            color="primary"
            className={this.determineButtonClass(config.placement)}
            onClick={() => this.toggleDrawer()}
          >
            {this.determineIcon(config.placement)}
          </Fab>
        }
      </React.Fragment>
    )
  }
}

HKVDrawer = withTranslation("translation")(HKVDrawer)
HKVDrawer = withStyles(styles, { withTheme: true })(HKVDrawer)
export default connect(state => state)(HKVDrawer)
